// extracted by mini-css-extract-plugin
export default {"component":"EOgvv6","reset":"xXPhiI"};